module.exports = __webpack_public_path__ + "img/show_cn_text_10.2d8ece99.png";